// Which Home a company gets, which menu items it sees and how its type is labelled, from today's capabilities
// (server/capabilities.js through useOrg). ONE place.
//   pure agent (agent and not manufacturing)  -> agent Home, no Inventory
//   everything else (distributor, manufacturer, agent + manufacturing) -> distributor Home, with Inventory
export const homeKindFor = (caps) => (caps && caps.agent && !caps.manufacturing ? 'agent' : 'distributor');

export function businessTypeKey(caps) {
  if (caps && caps.agent && caps.manufacturing) return 'biz.hybrid';
  if (caps && caps.manufacturing) return 'biz.manufacturer';
  if (caps && caps.agent) return 'biz.agent';
  return 'biz.distributor';
}
